import React from 'react';
import _ from 'lodash';
import 'hammerjs';
import { Box, Typography } from '@mui/material';
import ProgressChartWithTitle from './common/schartwithTitle';
import { useRecoilState } from 'recoil';
import { chartDataState } from '../recoil/atom';
import dayjs from 'dayjs';

const ProgressSummary = ({ height, width, criteriaDate }) => {
  const [chartData, setChartData] = useRecoilState(chartDataState);
  const sumWeightValue = _.sumBy(chartData.filter(v => v.monthweek === "M"), 'PV');

  const groupData_W = _(chartData.filter(v => v.monthweek === "W"))
    .groupBy('date')
    .map((objs, key) => ({
      date: key,
      'EV': (_.sumBy(objs, "EV") / sumWeightValue) * 100,
      'PV': (_.sumBy(objs, "PV") / sumWeightValue) * 100,
    }))
    .value();

  const calculateCumulativeValues = (data) => {
    let cumulativePV = 0;
    let cumulativeEV = 0;
    return data.map((item) => {
      cumulativePV += item.PV;
      cumulativeEV += item.EV || 0;
      return {
        ...item,
        cumulativePV,
        cumulativeEV,
      };
    });
  };

  const progressData = calculateCumulativeValues(groupData_W).map(item => {
    const itemDate = dayjs(item.date, 'YY년 WW주');
    if (itemDate.isAfter(criteriaDate)) {
      return { ...item, cumulativeEV: null };
    }
    return item;
  })

  const max = _.maxBy(progressData, "cumulativeEV")

  return (
    <Box display="flex" justifyContent="center" alignItems="center" padding="20px" height={height-45}>
      <Box display="flex" justifyContent="space-between" width="80%">
        <Box textAlign="center">
          <Typography variant="caption">계획 공정률</Typography>
          <Typography variant="subtitle1" sx={{fontSize:18, fontWeight:600}}>
            {max?.cumulativePV?.toFixed(1)}%
          </Typography>
        </Box>
        <Box textAlign="center">
          <Typography variant="caption">실적 공정률</Typography>
          <Typography variant="subtitle1" sx={{fontSize:18, fontWeight:600}}>
            {max?.cumulativeEV?.toFixed(1)}%
          </Typography>
        </Box>
        <Box textAlign="center">
          <Typography variant="caption">차이</Typography>
          <Typography variant="subtitle1" sx={{fontSize:18, fontWeight:600}}>
            {(max?.cumulativeEV - max?.cumulativePV)?.toFixed(1)}%
          </Typography>
        </Box>
      </Box>
    </Box>
  )
};

export default ProgressSummary